/**
 * Technical Analysis route — /technical/$ticker. Stock drill-down; same
 * ticker parse and search vocabulary as /stock/$ticker.
 */
import { StockSearchParamsSchema, type StockSearchParams } from '@meridian/contracts';

import { createTickerDrilldownRoute } from '@/lib/router/ticker-drilldown-route';

import type { TechnicalRouteProps } from './technical-route';
import type { ComponentType } from 'react';

export const technicalRoute = createTickerDrilldownRoute<StockSearchParams, TechnicalRouteProps>({
  path: '/technical/$ticker',
  crumbLabel: 'Technical Analysis',
  skeletonLabel: 'Loading technical analysis',
  load: () => import('./technical-route'),
  pick: (loaded) => loaded['TechnicalRoute'] as ComponentType<TechnicalRouteProps>,
  parseSearch: (search) => StockSearchParamsSchema.parse(search),
});
